export const METAMASK_DOWNLOAD_URL = 'https://metamask.io/download';
export const METAMASK_FLASK_DOWNLOAD_URL = 'https://metamask.io/flask';
